export default {"src":"/_next/static/media/youtube.feeb2015.svg","height":33,"width":46,"blurWidth":0,"blurHeight":0};